export default "__VITE_ASSET__CHOdMddM__"